/* eslint-disable max-len */
export const enUS = {
  all: "All",
  auth: {
    account_merge_required: "Account merge required",
    errors: {
      email_already_in_use: "This email is already in use",
      invalid_email: "Invalid email",
      popup_blocked: "Popup blocked",
      too_many_requests: "Too many requests",
      user_disabled: "User disabled",
      user_not_found: "User not found",
      weak_password: "Password too weak",
    },
    login_with_apple: "Login with Apple",
    login_with_facebook: "Login with Facebook",
    login_with_google: "Login with Google",
    password_reset_sent: "Password reset sent",
  },
  common: {
    close_modal: "Close modal",
  },
  company: {
    load_error: "Load error",
  },
  company_info: {
    closed_now: "Closed now",
    more_info: "More info",
    open_now: "Open now",
  },
  dashboard: {
    bookings: {
      actions: {
        cancel: "Cancel",
        confirm: "Confirm",
        deny: "Deny",
        edit: "Edit",
        view: "View",
      },
      bulk: {
        cancel: "Cancel",
        confirm: "Confirm",
        selected: "Selected",
      },
      bulk_update_fail: "Bulk update fail",
      bulk_update_partial_fail: "Bulk update partial fail",
      cancel: "Cancel",
      cancel_booking: "Cancel booking",
      cancel_fail: "We could not cancel your reservation, please try again",
      choose_time: "Choose a time",
      columns: {
        actions: "Actions",
        customer_email: "Customer email",
        customer_name: "Customer name",
        datetime: "Reservation date",
        seats: "Seats",
        status: "Status",
      },
      concierge: {
        back: "Back",
        booked: "Reserved at",
        camera_error: "Camera error",
        camera_generic_error: "Camera generic error",
        camera_not_found: "Camera not found",
        camera_permission_denied: "Camera permission denied",
        closereader: "Close reader",
        cod: "Code",
        confirm: "Confirm reservation",
        confirmed: "Confirmed people",
        contact: "Any questions? Contact the manager or administrator.",
        hello: "Hello Mr. Concierge!",
        is_invalid: "This reservation is outside your usage period.",
        last_scan_id: "id: {{booking_id}}",
        loading: "Loading reservation data...",
        mail: "Email",
        name: "Name",
        not_found: "Reservation not found",
        openreader: "Open reader",
        phone: "Phone",
        recomendation: "Please read another QR code and try again!",
        remain: "Remaining",
        scancode: "Reading Reservation QR code",
        scanned: "Reservation read",
        seatsfor: "Seats for",
        state: "State",
        switch_camera: "Switch Camera",
        usereader: "Use the reader below to read the reservation code.",
      },
      created_at: "Created at",
      created_fail: "We could not create a new reservation, please try again.",
      created_success: "New reservation created!",
      customer: {
        bookings: "Your reservations",
        complete: "Complete profile",
        email: "We have sent a confirmation email, please check your inbox.",
        menu: "Menu",
        none: "You don't have any reservations.",
        profile_updated: "Profile updated successfully!",
        qr_info: "Your reservation has been sent to your email, but can also be seen by clicking 'View QR Code'.",
        qr_modal_description: "Show this QR Code at the restaurant to confirm your reservation.",
        qr_modal_title: "Reservation QR Code",
        title: "Reservations",
        view_qr: "View QR Code",
      },
      delete_success: "Reservation Canceled!",
      dialogs: {
        confirmed: {
          message: "Do you want to confirm the reservation for '{{booking_title}}' seats? ",
          success: "Reservation confirmed!",
          title: "Confirm reservations",
        },
        edit: "Edit reservation",
        fail: {
          message: "Something went wrong when we tried to confirm this reservation, please try again!",
          title: "Oops!",
        },
      },
      edit_booking: "Edit booking",
      empty_suggestion: "Empty suggestion",
      filters: {
        all_status: "All status",
        date: "Date",
        date_range: "Date range",
        filters: "Filters",
        search: "Search",
        search_placeholder: "Search reservations...",
        status: "Reservation Status",
      },
      final_status: "The status of this reservation can no longer be changed.",
      how_many: "Table for how many people?",
      load_error: "Load error",
      no_availability: "No availability",
      no_bookings_concierge: "No bookings concierge",
      no_bookings_customer: "No bookings customer",
      no_date: "It was not possible to load the information available for the selected date, please select another date and try again.",
      notes: "Notes",
      people_count: "People count",
      refresh_error: "Refresh error",
      reservation: "Reservation",
      showing_count: "Showing count",
      status: {
        all: "All",
        canceled: "Canceled",
        cancelled: "Cancelled",
        completed: "Completed",
        confirmed: "Confirmed",
        created: "Awaiting confirmation",
        denied: "Denied",
        noshow: "No-show",
        partial: "Awaiting arrival of customers",
        pending: "Pending",
        used: "Already used",
      },
      status_error: "Status error",
      status_label: "Status label",
      table: {
        actions: "Actions",
        customer: "Customer",
        datetime: "Datetime",
        id: "Id",
        seats: "Seats",
        status: "Status",
      },
      title: "Reservation List",
      total_count: "Total count",
      update_fail: "Update fail",
      weekdays: {
        friday: "Fri",
        monday: "Mon",
        saturday: "Sat",
        sunday: "Sun",
        thursday: "Thu",
        tuesday: "Tue",
        wednesday: "Wed",
      },
    },
    categories: {
      actions: {
        delete: "Delete",
        disable: "Disable",
        edit: "Edit",
        enable: "Enable",
      },
      columns: {
        actions: "Actions",
        description: "Description",
        langs: "Registered Languages",
        name: "Name",
        order: "Order",
        status: "Status",
      },
      dialogs: {
        delete: {
          message: "Do you really want to delete the category '{{category_name}}'?",
          title: "Delete category",
        },
      },
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        all_languages_required: "All languages are required",
        basic_info: "Basic Information",
        create_title: "New Category",
        edit_title: "Edit Category",
        description: "Description",
        enabled: "Enable",
        name: "Category Name",
        order: "Order",
        order_placeholder: "1",
        texts: "Category Information",
      },
      new: "New category",
      not_found: "Category not found, please try again!",
      status: {
        disabled: "Disabled",
        enabled: "Enabled",
      },
      title: "Category List",
    },
    clear_filter: "Clear search and filters",
    company: {
      booking_title: "Reservations",
      bookings_title: "Reservation Hours",
      colors_title: "Colors and Styles",
      disclaimers_title: "Menu Legal Notices",
      form: {
        booking_approval: "Approve reservations",
        booking_interval: "Interval between reservations",
        booking_max_seats: "Maximum number of seats",
        booking_toleration: "Reservation tolerance",
        currency: "Currency",
        end: "End Time",
        lang: "Default Language",
        langs: "Available Languages",
        name: "Name",
        period: "Period",
        phone: "Phone Number",
        pics: "Items with Photo",
        qrcode_bg: "QR Code Background Color",
        qrcode_border: "QR Code Border Color",
        required: "Required field",
        seats: "Seats",
        start: "Start Time",
        street_address: "Address",
        theme: "Theme Color",
        timezone: "Company Timezone",
        weekday: "Day of the week",
      },
      periods_title: "Menu Schedule",
      request_error: "It was not possible to load the company information",
      runnings_title: "Opening Hours",
      time_title: "Timezone Information",
      title: "Company",
    },
    discounts: {
      columns: {
        actions: "Actions",
        items: "Items",
        name: "Name",
        percent: "Percentage %",
        period: "Period",
        type: "Type",
      },
      dialogs: {
        delete: {
          message: "Do you really want to delete the discount '{{discount_name}}' ?",
          title: "Delete discount",
        },
      },
      enabled: "Enabled",
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        apply_to: "Apply to",
        basic_info: "Basic Information",
        discount_info: "Discount Information",
        percent_placeholder: "0",
      },
      items: "Items (Foods / Categories)",
      name: "Name",
      new: "New discount",
      not_found: "Discount not found, please select another and try again!",
      percent: "Percentage %",
      period: "Period",
      title: "Discounts",
      type: "Type",
      types: {
        category: "Category",
        food: "Food",
      },
    },
    filters: {
      chips_label: "Active filter chips",
      expand_label: "Expand filters",
      summary_label: "Active filter summary",
    },
    foods: {
      actions: {
        delete: "Delete",
        disable: "Disable",
        edit: "Edit",
        enable: "Enable",
        price: "Edit Price",
      },
      card: {
        available_days_label: "Available days",
        available_periods_label: "Available periods",
        categories_label: "Categories",
        featured_label: "Featured",
        featured_tooltip: "Featured item",
        has_image_label: "Has image",
        has_image_tooltip: "Item has image",
        indicators_label: "Item indicators",
        original_price_label: "Original price",
        price_label: "Price",
        promo_price_label: "Promotional price",
        quick_actions_label: "Quick actions",
        status_badges_label: "Status badges",
      },
      columns: {
        actions: "Actions",
        categories: "Category",
        langs: "Registered Languages",
        name: "Name",
        periods: "Periods",
        price: "Price",
        status: "Status",
        weekdays: "Weekdays",
      },
      dialogs: {
        delete: {
          message: "Do you really want to delete the item '{{food_name}}'?",
          title: "Delete Item",
        },
        disable: {
          message: "Do you really want to disable the item '{{food_name}}'?",
          title: "Disable Item",
        },
        enable: {
          message: "Do you really want to enable the item '{{food_name}}'?",
          title: "Enable Item",
        },
        price: "Edit Price",
      },
      drag_warning: "Select exactly one category to sort items by dragging",
      featured: {
        all: "All",
        featured: "Featured",
        not_featured: "Not featured",
      },
      filters: {
        availability: "Availability",
        categories: "Categories",
        classification: "Classification",
        featured: "Featured",
        filter_active: "active filter",
        filters_active: "active filters",
        inclusive: "Inclusive",
        periods: "Times of day",
        preview: "View menu",
        search: "Search",
        search_text: "Search text",
        status: "Item Status",
        weekdays: "Days of the week",
      },
      form: {
        all_days: "Every day",
        all_languages_required: "All languages are required",
        all_periods: "All periods",
        availability: "Availability",
        basic_info: "Basic Information",
        categories: "Categories",
        categorization: "Categorization",
        change_image: "Change image",
        code: "Code",
        coffee: "Breakfast",
        create_title: "New Item",
        description: "Description",
        dine: "Dinner",
        edit_title: "Edit Item",
        enabled: "Enable",
        featured: "Featured",
        friday: "Friday",
        image: "Item image",
        lunch: "Lunch",
        monday: "Monday",
        name: "Name",
        new_category: "New Category",
        new_tag: "New Tag",
        no_categories: "No categories available",
        no_tags: "No tags available",
        order: "Order",
        periods: "Periods",
        price: "Price",
        price_label: "Price",
        promo_price: "Promotional price",
        promo_price_label: "Promotional price",
        saturday: "Saturday",
        snack: "Snack",
        sunday: "Sunday",
        tags: "Tags",
        texts: "Item Information",
        thursday: "Thursday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        weekdays: "Days",
      },
      grid_label: "Food items",
      new: "New Item",
      not_found: "Item not found, please select another and try again!",
      periods: {
        "": "",
        all: "All",
        coffee: "Coffee",
        dine: "Dine",
        lunch: "Lunch",
        snack: "Snack",
      },
      quick_filters: {
        active: "Active",
        featured: "Featured",
        inactive: "Inactive",
        on_sale: "On Sale",
      },
      statistics: {
        disabled: "Disabled",
        enabled: "Enabled",
        featured: "Featured",
        showing: "Showing",
      },
      statistics_label: "Food statistics summary",
      status: {
        all: "All",
        disabled: "Disabled",
        enabled: "Enabled",
      },
      title: "Menu Items List",
      view: {
        grid: "Grid",
        label: "Visualization",
        table: "Table",
      },
      weekdays: {
        "": "",
        all: "All",
        friday: "Friday",
        monday: "Monday",
        saturday: "Saturday",
        sunday: "Sunday",
        thursday: "Thursday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
      },
    },
    highlights: "Highlights",
    image: {
      error: "Something went wrong when uploading your image, please try again.",
      maxsize: "This image exceeds the maximum allowed size, please upload an image up to 5MB.",
      remove: "Something went wrong when deleting your image, please try again.",
    },
    menu: {
      bookings: "Reservations",
      categories: "Categories",
      change_password: "Change Password",
      company: "Company",
      discounts: "Discounts",
      foods: "Items",
      logout: "Logout",
      print_menu: "Print Menu",
      profile: "Profile",
      reader: "QR Reader",
      tags: "Tags",
      users: "Users",
    },
    no_dishes: "No dishes on the menu today.",
    not_found: "We didn't find any dish matching your search.",
    notifications: {
      not_supported: "Notifications are not supported in this browser",
    },
    reader: {
      people_count: "Number of people",
    },
    search_dish: "Search for your dish",
    stats: {
      all_time: "All Time",
      canceled: "Canceled",
      canceled_subtitle: "Canceled reservations",
      confirmed: "Confirmed",
      confirmed_subtitle: "Confirmed reservations",
      occupancy_rate: "Occupancy Rate",
      seats: "Seats",
      today_bookings: "Today's Reservations",
      today_subtitle: "Reservations for today",
      total_bookings: "Total Reservations",
      used: "Used",
      used_subtitle: "Used reservations",
    },
    tags: {
      columns: {
        actions: "Actions",
        langs: "Registered Languages",
        name: "Name",
      },
      dialogs: {
        delete: {
          message: "Do you really want to delete the tag '{{category_name}}'?",
          title: "Delete tag",
        },
      },
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        all_languages_required: "All languages are required",
        create_title: "New Tag",
        edit_title: "Edit Tag",
        name: "Tag Name",
        texts: "Tag Information",
      },
      new: "New tag",
      not_found: "Tag not found, please try again!",
      title: "Tags List",
    },
    title: "ZMenu Dashboard",
    users: {
      actions: {
        delete: "Delete",
        edit: "Edit",
      },
      columns: {
        actions: "Actions",
        fullname: "Full Name",
        mail: "Email",
        scopes: "Permissions",
        username: "Username",
      },
      dialogs: {
        delete: {
          message: "Do you really want to delete the user '{{user_name}}'?",
          title: "Delete user",
        },
      },
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        basic_info: "Basic Information",
        confirm_password: "Confirm Password",
        create_title: "New User",
        edit_title: "Edit User",
        fullname: "Full Name",
        mail: "Email",
        password: "Password",
        permissions: "Permissions",
        scopes: "Permissions",
        security: "Security",
        username: "Username",
      },
      new_singular: "New User",
      not_found: "User not found, please select another and try again!",
      profile: {
        change_password: "Change Password",
        title: "User Profile",
      },
      title: "Users List",
    },
    password_scores: {
      very_weak: "Very Weak",
      weak: "Weak",
      okay: "Okay",
      good: "Good",
      strong: "Strong",
    },
  },
  dialogs: {
    attention: "Attention",
    cancel: "Cancel",
    close: "Close",
    confirm: "Yes",
    confirmation: "Confirm",
    edit: "Edit",
    fail: "Oops!",
    gone_wrong: "Something went wrong, please try again!",
    invalid_login: "The login or password entered is invalid, please try again",
    login_error: "Login error. Please try again.",
    not_allowed: "This user is not authorized to use this module.",
    same_user: "There is already an account registered with the email {{ email }}. Try logging in with this account instead of associating this social account.",
    submit: "Send",
    success: "Success",
  },
  password_scores: {
    very_weak: "Very Weak",
    weak: "Weak",
    okay: "Okay",
    good: "Good",
    strong: "Strong",
  },
  footer: "made with love by ZMenu ©",
  forms: {
    common: {
      price_placeholder: "0.00",
      time_placeholder: "HH:mm",
    },
  },
  gone_wrong: "Something went wrong, please try again!",
  loading: "Loading",
  login: {
    email: "Email",
    facebook: "Facebook",
    google: "Google",
    password: "Password",
    sigin_apple: "Sign in with Apple",
    sigin_facebook: "Login with Facebook",
    sigin_google: "Login with Google",
    signup: "Sign up",
    submit: "Login",
    username: "User",
  },
  logout: "Logout",
  module: {
    disabled: "Module disabled, contact ZMenu Team to enable it.",
  },
  network: {
    back_online: "Connection restored",
    offline: "No connection",
    offline_error: "Connection error. Check your internet.",
  },
  of: "of",
  pdf: {
    categories: "Categories",
    clear_all: "Clear all",
    converting_category: "Converting category {{current}} of {{total}}...",
    description: "Select the categories you want to include in your menu for printing",
    download: "Download",
    download_success: "PDF downloaded successfully!",
    drag_to_reorder: "Drag to reorder categories in PDF",
    food_count: "{{count}} items",
    generate: "Generate PDF",
    generation_error: "Error generating PDF",
    generation_success: "PDF generated successfully!",
    include_prices: "Include prices",
    language: "Language",
    loading: "Loading...",
    merging_pdfs: "Merging PDFs...",
    no_categories: "No categories available",
    no_categories_selected: "Select at least one category",
    options: "Options",
    preparing_menu: "Preparing menu...",
    preview: "Preview PDF",
    preview_html: "Preview HTML",
    preview_html_title: "HTML Preview",
    preview_title: "PDF Preview",
    select_all: "Select all",
    selected_count: "{{count}} of {{total}} categories selected",
    settings: "PDF Settings",
    title: "Generate PDF Menu",
  },
  signup: {
    complete: "Complete your profile",
    confirm_password: "Confirm the chosen password",
    email: "Contact email",
    name: "Full name",
    password: "Choose your password",
    phone: "Phone / Mobile",
    submit: "Register",
    title: "Sign up",
  },
  validation: {
    email: "Email",
    error: "Error",
    maxLength: "Max length",
    minLength: "Min length",
    pattern: "Pattern",
    phone: "Phone",
    required: "Required",
  },
};